import React from 'react';
import { SubTabsTabDefinition } from 'apps/sigma2-ui/src/lib/hooks/useSubTabGroup';
import { SubTabsCountWithHeader } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { SubTabsHeader } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { Phrases } from 'libs/end-to-end/src/phrases';

export const getDeepDiveSubTabTabDefinitions = ({
  readyToDisplayDynamicContent,
  processBiasesNode,
  processBiasesCount,
  processBiasesHidden,
  explanatoryFactorsNode,
  explanatoryFactorsCount,
  calibrationFraming,
  language,
}: {
  readyToDisplayDynamicContent: boolean;
  processBiasesNode?: React.ReactNode;
  processBiasesCount?: number;
  processBiasesHidden?: boolean;
  explanatoryFactorsNode?: React.ReactNode;
  explanatoryFactorsCount?: number;
  calibrationFraming: CalibrationFraming;
  language: Phrases;
}) => {
  if (!readyToDisplayDynamicContent) {
    return [];
  }

  const processBiasTab: SubTabsTabDefinition = {
    // Process bias
    header: ({ isSelected }) => (
      <Spacing
        size={'sm'}
        direction={'horizontal'}
        as={'div'}
        className={'justify-center'}
      >
        <SubTabsHeader
          isSelected={isSelected}
          translatedContent={language.deepDiveSubTabProcessBiasTitle({
            calibrationFraming: calibrationFraming,
          })}
        />
        {processBiasesCount !== undefined && (
          <SubTabsCountWithHeader
            count={processBiasesCount}
            isSelected={isSelected}
          />
        )}
      </Spacing>
    ),
    body: () => processBiasesNode,
  };

  const explanatoryFactorsTab: SubTabsTabDefinition = {
    // Explanatory factors
    header: ({ isSelected }) => (
      <Spacing
        size={'sm'}
        direction={'horizontal'}
        as={'div'}
        className={'justify-center'}
      >
        <SubTabsHeader
          isSelected={isSelected}
          translatedContent={language.deepDiveSubTabExplanatoryFactorsTitle()}
        />
        {explanatoryFactorsCount !== undefined && (
          <SubTabsCountWithHeader
            count={explanatoryFactorsCount}
            isSelected={isSelected}
          />
        )}
      </Spacing>
    ),
    body: () => explanatoryFactorsNode,
  };

  const tabDefinitions: SubTabsTabDefinition[] = [
    ...(processBiasesHidden ? [] : [processBiasTab]),
    explanatoryFactorsTab,
  ];

  return tabDefinitions;
};
